import BreadCrumb from '../../../../components/Breadcrumb/breadCrumb'
import appointTable from './commonModel/appointmentTable.vue'
import {
  interApprReserveInfoList,
  interReserveInfoCancel,
  interReserveInfoDelete
} from '@/utils/appointment.url.js' // 引入接口
import {
  Loading
} from 'element-ui'
import {
  isPhone,
  idCardCheck,
  getCookie
} from '../../../../utils/utils.js'
export default {
  components: {
    BreadCrumb,
    appointTable
  },
  data () {
    // 手机号码验证
    var phoneVali = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入手机号码'))
      }
      if (!isPhone(value)) {
        return callback(new Error('请输入正确的手机号码'))
      }
      callback()
    }
    // 证件号码验证
    var idCardVali = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入证件号码'))
      }
      if (!idCardCheck(value)) {
        return callback(new Error('请输入正确的证件号码'))
      }
      callback()
    }
    return {
      wrongIdCard: false,
      wrongPhone: false,
      wrongName: false,
      // changeBtn: false,//查询按钮是否可用
      reserveList: [],
      searchInfoForm: {
        name: '', // 预约姓名
        idCard: '', // 预约身份证
        phone: '' // 预约手机
      },
      searchInfoFormRules: {
        name: {
          required: true,
          message: '请填写预约姓名',
          trigger: 'blur'
        },
        idCard: {
          required: true,
          validator: idCardVali,
          trigger: 'blur'
        },
        phone: {
          required: true,
          validator: phoneVali,
          trigger: 'blur'
        }
      },
      pageObj: {
        pageRowNum: 5,
        currPage: 1,
        totalPage: 7,
        totalRow: 0,
        pageIndex: 1
      }
    }
  },
  computed: {
    changeBtn: function () {
      if (this.searchInfoForm.name != '' && this.searchInfoForm.idCard != '' && this.searchInfoForm.phone != '') {
        return true
      }
    }
  },
  methods: {
    // 获取预约列表
    getReserveList (pageIndex) {
      let loading = Loading.service({
        fullscreen: true
      })
      interApprReserveInfoList({
        userName: this.searchInfoForm.name || sessionStorage.getItem('userName'), // 用户登录名
        paperCode: this.searchInfoForm.idCard || sessionStorage.getItem('paperCode'), // 用户身份证号码
        mobilePhone: this.searchInfoForm.phone || sessionStorage.getItem('mobilePhone'), // 用户手机号码
        pageRowNum: '10',
        pageIndex: pageIndex || '1'
      },
      'get'
      )
        .then(res => {
          loading.close()
          if (res.status == '200') {
            if (res.data.dataList.length > 0) {
              this.reserveList = res.data.dataList
              this.pageObj = res.data.pageObj
            } else {
              this.reserveList = []
              this.pageObj.totalRow = 0
            }
          } else {
            this.$message.error(res.desc)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 子组件中 分页触发 父组件的方法
    changePages (val) {
      this.pageObj.pageIndex = val
      this.getReserveList(val)
    },
    // 取消预约
    cancelOrder (reserveSeq, paperCode) {
      let loading = Loading.service({
        fullscreen: true
      })

      interReserveInfoCancel({
        loginaware: true,
        reserveSeq: reserveSeq,
        paperCode: paperCode
      },
      'get'
      )
        .then(res => {
          loading.close()
          if (res.status == '200') {
            if (res.data.status == '1') {
              this.$message.success('取消成功!')
              this.getReserveList(this.pageObj.pageIndex)
            } else {
              this.$message.error(res.data.desc)
            }
          } else {
            this.$message.error(res.desc)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 删除预约
    deletelOrder (reserveSeq, paperCode) {
      let loading = Loading.service({
        fullscreen: true
      })
      interReserveInfoDelete({
        loginaware: true,
        reserveSeq: reserveSeq,
        paperCode: paperCode
      },
      'get'
      )
        .then(res => {
          loading.close()
          if (res.status == '200') {
            if (res.data.status == '1') {
              this.$message.success('删除成功!')
              this.getReserveList(this.pageObj.pageIndex)
            } else {
              this.$message.error(res.data.desc)
            }
          } else {
            this.$message.error(res.desc)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    submitSearch () {
      this.$refs['searchInfoForm'].validate(valid => {
        if (valid) {
          this.getReserveList()
        }
      })
    }
  },
  watch: {},
  created () {
    const cookie = getCookie('access-token')
    if (this.$store.state.login) {
      this.getReserveList(this.pageObj.pageIndex)
    }
  }
}
